import { Deployment } from './types';
import { axiosClient } from '../axiosClient';

export const getDeployment = async (deploy_id: number) => {
  return axiosClient.get<Deployment>(`/deployments/${deploy_id}`);
};
